module.exports = __webpack_public_path__ + "images/social/default-2849ee59.jpg";